import React from "react";
import {
  Input,
  message,
  Select,
  Button,
  Space,
  Avatar,
  Row,
  Col,
  Dropdown,
  Modal,
  Tooltip,
  Switch,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";

import {
  DownloadOutlined,
  CloseOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { decode as base64_decode } from "base-64";
import companyStore from "../store/CompanyStore";
import DistributorStore from "../store/DistributorStore";
import withRouter from "../withRouter";
import ListTable from "./ListTable";

import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";
import Cookies from "js-cookie";
import AddAccount from "./AddAccount";

import AccountListCertificateDropdown from "./Plugins/AddAccount/AccountListCertificateDropdown";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import editIcon from "../assets/images/NewDesign/editIcon.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";

class CompanyList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSearch = this.onSearch.bind(this);

    this.selectDistributor = this.selectDistributor.bind(this);

    this.companyStore = new companyStore(this);
    this.distributorStore = new DistributorStore(this);

    this.companyRef = React.createRef();
    this.uploadFormRef = React.createRef();
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      distributor: "",
      distCompanyId: null,
      distributorType: "",
      status: "",
      company_name: "",
      companyVal_Lab: "",
      emailId: "",
      listUpdated: 0,
      waslStation: false,
      wasl: false,
      companyId: "",
      showDropdown: false,
      // export use
      dType: "",
      isadmin: "",
      cid: "",
      cType: "",
      cName: "",
      email: "",

      menuPropsDis: false,
      showUpload: false,

      createdBy: "",

      openAccountForm: false,
      companyIdForEdit: "",
      listDataUpdate: false,
      showStatusConfirm: false,
      inactiveCompanyId: "",
      isActive: false,
      AccountListFieldComponent: null,
      openDeleteModal: false,

      deleteData: {},
      editData: {},
    };
    this.user = Number(this.props.getUserData().isadmin);

    this.waslMenuProps = {
      items: [
        {
          label: (
            <Link to={"/waslcompanylist"}> {context.translate("_WASL_")}</Link>
          ),
          key: "1",
        },
        {
          label: (
            <Link to={"/waslstation"}>
              {" "}
              {context.translate("_WASL_STATION_")}
            </Link>
          ),
          key: "2",
        },
      ],
      onClick: () => {},
    };

    this.waslMenuList = {
      items: [
        {
          label: (
            <Link
              to={"/waslcompanylist"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                textDecoration: "none",
              }}
            >
              {" "}
              <PlusOutlined
                style={{ height: "14px", width: "14px", borderRadius: "0px" }}
              />
              {context.translate("_WASL_")}
            </Link>
          ),
          key: "wasl",
        },
        {
          label: (
            <Link
              to={"/waslstation"}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                textDecoration: "none",
              }}
            >
              {" "}
              <PlusOutlined
                style={{ height: "14px", width: "14px", borderRadius: "0px" }}
              />
              {context.translate("_WASL_STATION_")}
            </Link>
          ),
          key: "waslstation",
        },
      ],
    };

    this.columns = [
      {
        // title: "Account Name",
        title: context.translate("_FLEET_COMPANY_COMPANYLIST_COMPANYNAME_"),
        dataIndex: "name",
        width: 100,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          // if (
          //   Number(this.props.getUserData().isadmin) === -1 ||
          //   Number(this.props.getUserData().isadmin) === 3
          // ) {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("companyList") && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
          // } else {
          //   return value;
          // }
        },
      },
      {
        title: context.translate("_COMPANY_NAME_ARABIC_"),
        dataIndex: "companyNameArabic",
        width: 100,
        ellipsis: true,
        render: (companyNameArabic) => (
          <Tooltip placement="topLeft" title={companyNameArabic}>
            <div>{companyNameArabic}</div>
          </Tooltip>
        ),
      },
      {
        // title: "Contact Phone",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_PHONE_"),
        dataIndex: "contact1No",
        width: 80,
        ellipsis: true,

        render: (contact1No) => (
          <Tooltip placement="topLeft" title={contact1No}>
            <div>{contact1No}</div>
          </Tooltip>
        ),
      },
      {
        // title: "Contact Email",
        title: context.translate("_FLEET_COMPANY_COMPANYLIST_EMAIL_"),
        dataIndex: "contact1Email",
        width: 90,
        ellipsis: true,

        render: (contact1Email) => (
          <Tooltip placement="topLeft" title={contact1Email}>
            <div>{contact1Email}</div>
          </Tooltip>
        ),
      },
      {
        // title: "Created By",
        title: context.translate("_CREATED_BY_"),
        dataIndex: "createdBy",
        width: 80,
        ellipsis: true,

        render: (createdBy) => (
          <Tooltip placement="topLeft" title={createdBy}>
            <div>{createdBy}</div>
          </Tooltip>
        ),
        // render: (value) => {
        //   return (
        //     <span>
        //       <Avatar
        //         style={{ backgroundColor: config.userColor, margin: 2 }}
        //         size={15}
        //         icon={<UserOutlined />}
        //       />
        //       {value}
        //     </span>
        //   );
        // },
      },
      {
        // title: "Create Date",
        title: context.translate("_CREATE_DATE"),
        dataIndex: "createDate",
        width: 80,
        ellipsis: true,

        render: (createDate) => (
          <Tooltip placement="topLeft" title={createDate}>
            <div>{createDate}</div>
          </Tooltip>
        ),
      },
      {
        // title: "Type",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_TYPE_"),
        dataIndex: "customerDistributor",
        width: 60,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value == "Customer") {
            return <div className="list-status-type">{value}</div>;
            // <Tag color={config.typeColor1}>{value}</Tag>;
          }
          if (value == "Distributor") {
            return <div className="list-status-typeDist">{value}</div>;
            // <Tag color={config.typeColor2}>{value}</Tag>;
          }
        },
      },
      {
        title: context.translate("_AGREEMENT_"),
        dataIndex: "agreement",
        key: "agreement",
        width: 80,
        align: "center",
        render: (val) => {
          return (
            <DownloadOutlined
              onClick={() => {
                this.companyStore.downloadTradeLicense(val);
              }}
            />
          );
        },
      },
      {
        title: context.translate("_TRADE_LICENSE_"),
        dataIndex: "tradelicense",
        key: "tradelicense",
        width: 70,
        align: "center",
        render: (val) => {
          return (
            <DownloadOutlined
              onClick={() => {
                this.companyStore.downloadTradeLicense(val);
              }}
            />
          );
        },
      },
      {
        // title: "Status",
        title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
        dataIndex: "status2",
        width: 80,
        ellipsis: {
          showTitle: true,
        },
        render: (mainValue) => {
          let value = Number(mainValue);

          if (value === 1) {
            return (
              // <Tag
              //   style={{ width: "56px", textAlign: "center" }}
              //   color={config.deleteColor}
              // >
              //   Expired
              // </Tag>
              <div className="list-status-expired">Expired</div>
            );
          } else if (value === 2) {
            return (
              // <Tag
              //   style={{ width: "87px", textAlign: "center" }}
              //   color={config.ExpirySoonColor}
              // >
              //   Expiring Soon
              // </Tag>
              <div className="list-status-expiringSoon">Expiring Soon</div>
            );
          } else if (value === 3) {
            return (
              <div className="list-status-active">Active</div>
              // <Tag
              //   style={{ width: "56px", textAlign: "center" }}
              //   color={config.activeColor}
              // >
              //   Active
              // </Tag>
            );
          } else if (value === 4) {
            return (
              // <Tag
              //   style={{ width: "56px", textAlign: "center" }}
              //   color={config.inActiveColor}
              // >
              //   Inactive
              // </Tag>
              <div className="list-status-inactive">Inactive</div>
            );
          }
        },
      },

      {
        // title: "Action",
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        // fixed: "right",
        width: 60,
        align: "center",
        render: (_, record) => {
          return (
            <>
              {(Number(this.props.getUserData().isadmin) === -1 ||
                Number(this.props.getUserData().isadmin) === 3) && (
                <Space style={{ alignItems: "baseline" }}>
                  <Tooltip
                    title={
                      record.status == "1"
                        ? this.context.translate("_ACTIVE_")
                        : this.context.translate(
                            "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                          )
                    }
                    placement="top"
                    color={
                      record.status == "1"
                        ? config.activeColor
                        : config.inActiveColor
                    }
                  >
                    {this.props.canUpdate("companyList") && (
                      <Switch
                        className="switch-btn"
                        size="small"
                        // className="form-offlineAlerts"
                        checked={Number(record.status)}
                        // checkedChildren="Yes"
                        // unCheckedChildren="No"
                        // checkedChildren={this.context.translate(
                        //   "_ACTIVE_"
                        // )}
                        // unCheckedChildren={this.context.translate(
                        //   "_IN_ACTIVE_"
                        // )}
                        onChange={async (val) => {
                          this.setState({
                            inactiveCompanyId: record.companyId,
                          });
                          this.setState({ isActive: val });
                          this.setState({ showStatusConfirm: true }); // open modal
                        }}
                        // defaultChecked
                      />
                    )}
                  </Tooltip>

                  {this.props.canDelete("companyList") && (
                    <Tooltip
                      title={this.context.translate("_DELETE_ACCOUNT_")}
                      placement="bottom"
                    >
                      <Image
                        src={require("../assets/images/NewDesign/Delete.png")}
                        style={{ cursor: "pointer", width: "15px" }}
                        onClick={() =>
                          this.setState({
                            openDeleteModal: true,
                            deleteData: record,
                          })
                        }
                      ></Image>
                    </Tooltip>
                  )}

                  <Dropdown menu={this.actionColumn} trigger={["click"]}>
                    <Image
                      style={{ cursor: "pointer", width: "6px" }}
                      src={kebabIcon}
                      onClick={(e) => {
                        e.preventDefault();
                        this.setState({ editData: record });
                      }}
                    ></Image>
                  </Dropdown>
                </Space>
              )}
            </>
          );
        },
      },
    ];

    let column = this.columns;
    if (this.user === -1 || this.user === 3) {
      column = this.columns;
    } else {
      column = this.columns.filter((val) => val.dataIndex !== "Action");
    }
    this.columns = column;

    let hideColumns = this.columns;
    if (
      config.project === "awtltrack" ||
      config.project === "starlingeye" ||
      config.project === "trackeazy" ||
      config.project === "nodeui"
    ) {
      hideColumns = this.columns?.filter(
        (val) =>
          val.dataIndex !== "tradelicense" && val.dataIndex !== "agreement"
      );
    }
    this.columns = hideColumns;
  }
  closeModal = () => {
    this.setState({ openAccountForm: false, companyIdForEdit: "" });
  };
  onEdit = async (record) => {
    await this.context.viewStateStore.setAccountStates({
      distributorType: this.state.distributorType,
      companyId: this.state.companyId,
      createdBy: this.state.createdBy,
      distCompanyId: this.state.distCompanyId,
      filterByType: this.state.distributorType,
      status: this.state.status,
      emailId: this.state.emailId,
    });

    await this.setState({ companyIdForEdit: record.companyId });
    await this.setState({ openAccountForm: true });
  };

  async onDelete(record) {
    const response = await this.companyStore.deleteRecord({
      companyId: record.companyId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch({ distCompanyId: null });
    } else {
      message.error(response.data.message);
    }
  }
  onExcelSubmit = async (fieldsValue) => {
    let userId = JSON.parse(base64_decode(Cookies.get("data"))).userId;
    const resp = await this.companyStore.accountImport(
      this.state.excelFile,
      userId
    );

    if (resp?.success == "1") {
      message.success(resp.message);
      this.setState({ showUpload: false });
      this.setState({ excelFile: "" });
    } else {
      message.error(resp.message);
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (Number(this.props.getUserData().isadmin) === 0) {
      this.props.navigate("/login");
    }

    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const viewStateStoreArray = this.context.viewStateStore.accountStatesObj;

      const distCompanyId = viewStateStoreArray.distCompanyId;

      const companyId = viewStateStoreArray.companyId;
      const distributorType = viewStateStoreArray.distributorType
        ? viewStateStoreArray.distributorType
        : null;
      await this.setState({ distributorType: distributorType });
      const status =
        viewStateStoreArray.status >= 0 ? viewStateStoreArray.status : null;

      await this.setState({ status: status });
      const emailId = viewStateStoreArray.emailId
        ? viewStateStoreArray.emailId
        : null;

      await this.setState({ distCompanyId, companyId });
      const singleData = await this.companyStore.getCompanyDataById(
        viewStateStoreArray.companyId
      );

      if (distCompanyId > 0) {
        await this.setState({
          companyVal_Lab: singleData,
          distributorType: distributorType,
          status: status,
          emailId: emailId,
        });
        await this.handleSearch({
          distCompanyId,
          companyId,
          distributorType,
          status,
          emailId,
        });
      } else {
        await this.setState({
          companyVal_Lab: singleData,
          distributorType,
          status: status,
          emailId: emailId,
        });
        await this.handleSearch({
          distCompanyId: null,
          companyId,
          distributorType: null,
          status,
          emailId,
        });
      }
      this.setState({ listDataUpdate: false });
    }
  }
  async componentDidMount() {
    if (Number(this.props.getUserData().isadmin) !== -1) {
      this.setState({ companyId: this.props.getUserData().userCompanyId });
    }

    this.ExportMenuProps = {
      items: [
        {
          // label: "Excel",
          label: this.context.translate("_EXPORT_AS_EXCEL_"),
          key: "excel",
          icon: (
            <Image
              style={{ height: "16px", width: "16px" }}
              src={Excel}
            ></Image>
          ),
        },
        {
          // label: "PDF",
          label: this.context.translate("_EXPORT_AS_PDF_"),
          key: "pdf",
          icon: (
            <Image style={{ height: "16px", width: "16px" }} src={PDF}></Image>
          ),
        },
      ],
      onClick: (val) => {
        const result = [];
        this.columns.map((obj) => {
          if (obj.dataIndex === "status2") {
            result.push("status");
          } else {
            result.push(obj.dataIndex);
          }
        });

        var getData = {
          dType: this.state.dType,
          isadmin: JSON.parse(base64_decode(Cookies.get("data"))).isadmin,
          cid: this.state.companyId,
          cType: this.state.distributorType,
          cName: this.state.cName,
          email: this.state.emailId,
          colList: result,
          cstatus: this.state.status,
        };

        if (val.key == "excel") {
          this.companyStore.exportExcel(getData);
        }
        if (val.key == "pdf") {
          this.companyStore.exportPdf(getData);
        }
      },
    };

    this.actionColumn = {
      items: [
        this.props.canUpdate("companyList") && {
          // label: "Excel",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.onEdit(this.state.editData)}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
              ></Avatar>
              {this.context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
          // icon: (

          // ),
        },
      ],
    };
    await this.distributorStore.distributorList();

    await this.handleSearch({ distCompanyId: null, distributorType: null });
    await this.setState({ listUpdated: 1 }); //need to reload data

    // this.handleSearch()
    this.setState({ pageSize: 50 });
  }
  importComponent = async () => {
    try {
      const component = await import(
        `./Plugins/${config.project}_AddAccount/AccountListFields`
      );
      this.setState({ AccountListFieldComponent: component.default });
    } catch (error) {
      console.error("Error loading AccountListFields component:", error);
    }
  };

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch({
      distCompanyId: null,
      companyId: null,
      status: null,
      emailId: null,
      distributor: null,
      distributorType: null,
    });
  }

  async selectDistributor(value, option) {
    await this.setState({
      distCompanyId: value,
      createdBy: option.name,
      currentPage: 1,
    });
    // await this.setState({ distributorType: [{value:value,label:option.createdBy}] });

    await this.handleSearch({
      offset: 0,
      distCompanyId: null,
      companyId: null,
      status: null,
      emailId: null,
      distributor: null,
      distributorType: null,
    });
  }

  async handleChange(comp) {
    this.setState({ cName: comp.label, companyId: comp.value, currentPage: 1 });
    let companyId = -1;
    if (comp !== undefined) {
      companyId = comp.value;
    }
    const singleData = await this.companyStore.getCompanyDataById(companyId, 1);

    await this.setState({ companyVal_Lab: singleData });

    await this.setState({ currentPage: 1, companyId: companyId });
    await this.handleSearch({
      distCompanyId: null,
      companyId: companyId,
      status: null,
      emailId: null,
    });
  }

  async onSearch(value) {
    await this.setState({ emailId: value, pageSize: 50, currentPage: 1 });
    this.handleSearch({
      distCompanyId: null,
      companyId: null,
      status: null,
      emailId: null,
      distributor: null,
      distributorType: null,
    });
  }

  async handleSearch({
    distCompanyId,
    companyId,
    status,
    emailId,
    distributor,
    distributorType,
    offset,
  }) {
    this.setState({ loading: true });
    await this.companyStore.loadData({
      offset:
        // offset == 0
        //   ? offset
        //   : (this.state.currentPage - 1) * this.state.pageSize,

        (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      distCompanyId:
        distCompanyId > 0 && distCompanyId !== null
          ? distCompanyId
          : this.state.distCompanyId,
      emailId: emailId ? emailId : this.state.emailId,
      status: this.state.status,
      company_name: this.state.cName,
      distributorType: this.state.distributorType,
      searchCompanyId: companyId > 0 ? companyId : this.state.companyId,
      cname: this.state.cName,
      // companyId: 358,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }
  handleClear = async () => {
    await this.setState({ companyVal_Lab: null, companyId: "", cName: "" });

    await this.companyStore.loadData({
      companyId: "1",
      isadmin: "-1",
      offset: 0,
      limit: this.state.pageSize,
    });
    await this.setState({ loadData: 1 });
  };

  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    if (fileinfo?.success == "S") {
      await this.setState({ excelFile: fileinfo.data });
    }

    this.setState({ update: 1 });
  };

  responseMsg = async (response) => {
    if (response?.success === "S") {
      message.success(response.message);
      // this.props.navigate("/companylist");
      this.setState({ openAccountForm: false });
      this.setState({ listDataUpdate: true });
    } else {
      if (response.errors[0].companyname) {
        message.error(this.context.translate(response.errors[0]?.companyname));
      }
      if (response.errors[0]?.username) {
        message.error(this.context.translate(response.errors[0]?.username));
      }
      this.setState({ loading: false });
    }
  };

  confirmStatus = async (
    distCompanyId,
    emailId,
    company_name,
    distributorType,
    searchCompanyId,
    cname
  ) => {
    // alert("Work In Progress");
    // this.companyStore?.companies = [];
    const data = {};

    data.companyId = this.state.inactiveCompanyId;
    data.activeStatus = this.state.isActive == true ? 1 : 0;

    await this.companyStore.updateStatus(data);

    this.setState({ showStatusConfirm: false });

    await this.setState({ loading: true });
    await this.companyStore.loadData({
      offset: 0,
      limit: 50,
      distCompanyId:
        distCompanyId > 0 && distCompanyId !== null
          ? distCompanyId
          : this.state.distCompanyId,
      emailId: emailId ? emailId : this.state.emailId,
      status: this.state.status,
      company_name: this.state.cName,
      distributorType: this.state.distributorType,
      searchCompanyId:
        searchCompanyId > 0 ? searchCompanyId : this.state.companyId,
      cname: this.state.cName,
    });

    await this.setState({ loading: false });
  };
  cancelConfirm = async (response) => {
    this.setState({ showStatusConfirm: false });
  };
  setshowUpload = (val) => {
    this.setState({ showUpload: val });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.companyStore.loadData({
      offset: 0,
      limit: 50,
    });
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    const { AccountListFieldComponent } = this.state;
    return (
      <>
        {/* <div style={{ padding: 0 }}>
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
            <Row className="headerFixed" style={{ height: "50px" }}>
              <Col span={12}>
               
                <div className="heading">
                  {this.context.translate("_ACCOUNT_LIST_")}
                </div>
              </Col>
              <Col
                span={12}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <Space>
                  <Space
                    style={{
                      float:
                        this.context.locale.direction == "ltr"
                          ? "right"
                          : "left",
                    }}
                  >
                  

                    {AccountListFields ? (
                      <AccountListFields
                        setshowUpload={this.setshowUpload}
                        menu={this.waslMenuProps}
                      />
                    ) : null}


                  </Space>
                </Space>
              </Col>
            </Row>
          )}



        </div> */}

        <div className="listHeader">
          {(Number(this.props.getUserData().isadmin) === -1 ||
            Number(this.props.getUserData().isadmin) === 3) && (
            <Row className="listInputRow">
              <Col span={16}>
                <Space>
                  <CompanyAutocomplete
                    className="searchInput"
                    ref={this.companyRef}
                    onChange={(val) => {
                      this.handleChange(val);
                    }}
                    value={
                      this.state.companyVal_Lab
                        ? this.state.companyVal_Lab
                        : null
                    }
                    allowClear={true}
                    onClear={this.handleClear}
                    style={{ width: 165 }}
                    fromAccountList={1}
                  />
                  {Number(this.props.getUserData().isadmin) === -1 && (
                    <Select
                      className="searchInput"
                      style={{
                        width: 170,
                      }}
                      fieldNames={{ label: "name", value: "companyId" }}
                      value={
                        this.state.distCompanyId
                          ? this.state.distCompanyId
                          : null
                      }
                      // placeholder=" Select Distributor1"
                      placeholder={this.context.translate(
                        "_SELECT_DISTRIBUTOR1_"
                      )}
                      onChange={async (val, option) => {
                        await this.selectDistributor(val, option);
                        await this.setState({ distCompanyId: val });
                      }}
                      optionFilterProp="children"
                      options={this.distributorStore?.distributors}
                    />
                  )}

                  {Number(this.props.getUserData().isadmin) === -1 && (
                    <Select
                      className="searchInput"
                      style={{
                        width: 180,
                      }}
                      value={
                        this.state.distributorType
                          ? this.state.distributorType
                          : null
                      }
                      placeholder={this.context.translate("_FILTER_TYPE_")}
                      optionFilterProp="children"
                      onSelect={async (value) => {
                        await this.setState({
                          distributorType: value,
                          currentPage: 1,
                        });
                        await this.handleSearch({
                          distCompanyId: null,
                          companyId: null,
                          distributorType: null,
                          status: null,
                        });
                      }}
                      options={[
                        {
                          value: "All",
                          label: "All",
                          // label:this.context.translate("_ALL_")
                        },
                        {
                          value: "Customer",
                          label: "Customer",
                          // label:this.context.translate("_FLEET_CUSTOMER_")
                        },
                        {
                          value: "Distributor",
                          label: "Distributor",
                          // label:this.context.translate("_DISTRIBUTOR_")
                        },
                      ]}
                    />
                  )}

                  {Number(this.props.getUserData().isadmin) === 3 && (
                    <Select
                      className="searchInput"
                      style={{
                        width: 180,
                      }}
                      value={
                        this.state.distributorType
                          ? this.state.distributorType
                          : null
                      }
                      placeholder={this.context.translate("_FILTER_TYPE_")}
                      optionFilterProp="children"
                      onSelect={async (value) => {
                        await this.setState({
                          distributorType: value,
                          currentPage: 1,
                        });
                        await this.handleSearch({
                          distCompanyId: null,
                          companyId: null,
                          distributorType: null,
                          status: null,
                        });
                      }}
                      options={[
                        {
                          value: "All",
                          label: "All",
                          // label:this.context.translate("_ALL_")
                        },
                        {
                          value: "Customer",
                          label: "Customer",
                          // label:this.context.translate("_FLEET_CUSTOMER_")
                        },
                        // {
                        //   value: "Distributor",
                        //   label: "Distributor",
                        //   // label:this.context.translate("_DISTRIBUTOR_")
                        // },
                      ]}
                    />
                  )}

                  <AccountListCertificateDropdown />

                  <Select
                    className="searchInput"
                    style={{
                      width: 150,
                    }}
                    placeholder={this.context.translate(
                      "_FLEET_USER_USERLIST_STATUS_"
                    )}
                    value={
                      this.state.status !== "" ? this.state.status : undefined
                    }
                    optionFilterProp="children"
                    onSelect={async (value) => {
                      await this.setState({ status: value, currentPage: 1 });
                      await this.handleSearch({
                        distCompanyId: null,
                        companyId: null,
                        distributorType: null,
                        status: null,
                      });
                      await this.setState({ listUpdated: 1 });
                    }}
                    options={[
                      {
                        value: 0,
                        label: "All",
                        // label:this.context.translate("_ALL_")
                      },
                      {
                        value: 1,
                        label: "Expired",
                        // label:this.context.translate("_EXPIRED_")
                      },
                      {
                        value: 2,
                        label: "Expiring Soon",
                        // label:this.context.translate("_EXPIRINGSOON_")
                      },
                      {
                        value: 3,
                        label: "Active",
                        // label:this.context.translate("_FLEET_USER_USERLIST_STATUS_ACTIVE_")
                      },
                      {
                        value: 4,
                        label: "Inactive",
                        // label:this.context.translate("_FLEET_USER_USERLIST_STATUS_INACTIVE_")
                      },
                    ]}
                  />

                  <Input
                    className="searchInput"
                    onChange={(e) => {
                      this.setState({ emailId: e.target.value });
                      this.onSearch(e.target.value);
                    }}
                    style={{
                      width: 200,
                      borderRadius: "25px",
                    }}
                    placeholder={this.context.translate(
                      "_FLEET_USER_USERLIST_EMAIL_"
                    )}
                    allowClear
                    value={this.state.emailId ? this.state.emailId : ""}
                  ></Input>
                </Space>
              </Col>
              <Col
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
                span={8}
              >
                <Space>
                  <Tooltip
                    title={this.context.translate("_REFRESH_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: 18,
                        marginInlineEnd: "20px",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      src={refreshIcon}
                      onClick={() => {
                        this.refreshList();
                        this.setState({
                          distCompanyId: "",
                          distributorType: "",
                          status: "",
                          emailId: "",
                        });
                      }}
                    ></Image>
                  </Tooltip>

                  {(Number(this.props.getUserData().isadmin) == -1 ||
                    Number(this.props.getUserData().isadmin) == 3) && (
                    <Dropdown
                      overlayClassName="export-dropdown"
                      menu={this.waslMenuList}
                    >
                      <Image
                        style={{
                          height: 18,
                          alignItems: "center",
                          marginInlineEnd: "20px",
                        }}
                        src={kebabIcon}
                      ></Image>
                    </Dropdown>
                  )}
                  <Tooltip
                    title={this.context.translate("_DOWNLOAD_")}
                    placement="bottom"
                  >
                    <span>
                      <Button
                        className="downloadExcelButton"
                        disabled={
                          this.companyStore?.companies?.length > 0
                            ? false
                            : true
                        }
                        onClick={(val) => {
                          let result = [];
                          if (true) {
                            this.columns.map((obj) => {
                              if (obj.dataIndex === "status2") {
                                result.push("status");
                              } else {
                                result.push(obj.dataIndex);
                              }
                            });

                            var getData = {
                              dType: this.state.dType,
                              isadmin: JSON.parse(
                                base64_decode(Cookies.get("data"))
                              ).isadmin,
                              cid: this.state.companyId,
                              cType: this.state.distributorType,
                              cName: this.state.cName,
                              email: this.state.emailId,
                              colList: result,
                              cstatus: this.state.status,
                            };

                            if (val) {
                              this.companyStore.exportExcel(getData);
                            }
                          }
                        }}
                      >
                        <Image
                          style={{
                            height: 18,
                            width: "auto",
                          }}
                          src={downloadIcon}
                        />
                      </Button>
                    </span>
                  </Tooltip>
                  {this.props.canCreate("companyList") && (
                    <Button
                      className="addButtonClass"
                      onClick={() =>
                        this.setState({
                          openAccountForm: true,
                          companyIdForEdit: "",
                        })
                      }
                    >
                      <Image
                        style={{ marginInlineEnd: "5px", width: 13 }}
                        src={require("../assets/images/NewDesign/plus (Stroke).png")}
                      ></Image>
                      {this.context.translate(
                        "_FLEET_DRIVER_DRIVERLIST_ADDBTN_"
                      )}
                    </Button>
                  )}
                </Space>
              </Col>
            </Row>
          )}
          <ListTable
            currentPage={this.state.currentPage}
            total={this.companyStore?.total}
            columns={this.columns}
            dataSource={this.companyStore?.companies}
            pageSize={this.state.pageSize}
            loading={this.companyStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {/* {this.state.showUpload && (
          <Modal
            open={this.state.showUpload}
            maskClosable={false}
            // title="File Upload"
            title={this.context.translate("_FILE_UPLOAD_")}
            onOk={() => this.setState({ showUpload: false })}
            onCancel={() => {
              this.setState({ showUpload: false, excelFile: "" });
            }}
            footer={false}
            width={400}
          >
            <Form
              ref={this.uploadFormRef}
              name="excelimport"
              layout="vertical"
              onFinish={this.onExcelSubmit}

              // className="formClass"
            >
              <Form.Item
                name="excelFile"
                // label="Excel File"
                style={{ marginTop: "15px" }}
                rules={[{ required: true, message: "Please enter excel file" }]}
              >
                <Upload
                  name="excelFile"
                  action={config.baseURL + "/index.php?c=company&a=fileupload"}
                  listType="text"
                  data={{ fileType: "accountimport", fieldName: "excelFile" }}
                  onChange={this.getUploadData}
                  maxCount={1}
                >
                  <Button icon={<UploadOutlined />}>
                    {this.context.translate("_CLICKTOUPLOAD_EXCELFILE_")}
                  </Button>
                </Upload>
              </Form.Item>

              <div className="formBtnGroup">
                <Button
                  className="formCancelButton"
                  // style={{ backgroundColor: config.activeColor }}
                  onClick={() => this.companyStore.sampleExcel()}
                >
                  {this.context.translate("_SAMPLE_")}
                </Button>

                <Button
                  type="primary"
                  className="formSaveButton"
                  htmlType="submit"
                  // loading={this.state.loading}
                >
                  {this.context.translate("_UPLOAD_")}
                 
                </Button>
              </div>
             
            </Form>
          </Modal>
        )} */}
        {this.state.openAccountForm && (
          // <Modal
          //   className="formShowModal"
          //   maskClosable={false}
          //   title={this.context.translate(
          //     "_FLEET_COMPANY_COMPANYDETAIL_TITLE_"
          //   )}
          //   centered
          //   visible={this.state.openAccountForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openAccountForm: false, companyIdForEdit: "" });
          //   }}
          //   width={665}
          // >
          <Drawer
            className="accountFormDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openAccountForm}
            placement={
              this.context.locale.language === "english" ? "right" : "left"
            }
            footer={false}
            // title={
            //   <div className="formTitle">
            //     {this.context.translate("_FLEET_DRIVER_DRIVERDETAIL_TITLE_")}
            //     <p className="formDescription">
            //       {this.context.translate("_DRIVER_ADD_DESC_")}
            //     </p>
            //   </div>
            // }
            maskClosable={false}
            onOk={() => this.setState({ openAccountForm: false })}
            onCancel={() =>
              this.setState({ openAccountForm: false, companyIdForEdit: "" })
            }
          >
            <div style={{ height: "100%" }}>
              <AddAccount
                companyIdForEdit={this.state.companyIdForEdit}
                closeModal={this.closeModal}
                response={this.responseMsg}
              />
            </div>
          </Drawer>
        )}

        {this.state.showStatusConfirm && (
          <Modal
            maskClosable={false}
            title={
              <div className="confirmStatusTitle">
                <span>{this.context.translate("_CONFIRM_")}</span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ showStatusConfirm: false })}
                />
              </div>
            }
            className="update-statusModal"
            description="Are you sure to change this status?"
            centered
            open={this.state.showStatusConfirm}
            footer={null}
            // onOk={this.confirmStatus}
            width={400}
            closable={false}
          >
            <div className="confirmStatusText">
              {this.state.isActive === true ? (
                <p>{this.context.translate("_STATUS_ACTIVE_")}</p>
              ) : (
                <p>{this.context.translate("_STATUS_INACTIVE_")}</p>
              )}
            </div>
            <div className="confirmStatusButtons">
              <Button
                onClick={() => this.setState({ showStatusConfirm: false })}
                className="confirmStatusCancelButton"
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="confirmStatusOkButton"
                onClick={() =>
                  this.confirmStatus(
                    this.state.distCompanyId,
                    this.state.emailId,
                    this.state.status,
                    this.state.cName,
                    this.state.distributorType,
                    this.state.companyId,
                    this.state.cName
                  )
                }
              >
                {this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_COMMAND_OKBTN_"
                )}
              </Button>
            </div>
          </Modal>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
CompanyList.contextType = StoreContext;
export default observer(withRouter(CompanyList));
